export const TOGGLE_DRAWER = "TOGGLE_DRAWER";
export const SET_TOOLBAR = "SET_TOOLBAR";
export const TOGGLE_TAG = "TOGGLE_TAG";
export const SET_TAGS = "SET_TAGS";
export const SET_SORT = "SET_SORT";
export const SET_QUERY = "SET_QUERY";
export const SET_DATA = "SET_DATA";
